module.exports = __webpack_public_path__ + "fonts/241672c.eot";